import axiosInstance from "../components/auth/interceptor";
import {
  VinalfaChildrenResponse,
  VinalfaGroupsResponse,
  VinalfaPartsResponse,
  VinalfaResolveResponse,
} from "../interfaces/Vinalfa";

const baseURL = process.env.REACT_APP_API_URL;

export async function resolveVehicleByVin(
  identifier: string
): Promise<VinalfaResolveResponse> {
  const response = await axiosInstance.post(
    `${baseURL}/vinalfa/vehicles/resolve`,
    { identifier: identifier.trim() }
  );
  return response.data as VinalfaResolveResponse;
}

export async function fetchVinalfaGroups(
  vehicleHash: string
): Promise<VinalfaGroupsResponse> {
  const response = await axiosInstance.get(
    `${baseURL}/vinalfa/vehicles/${encodeURIComponent(vehicleHash)}/groups`
  );
  return response.data as VinalfaGroupsResponse;
}

export async function fetchVinalfaSectionChildren(
  sectionHash: string
): Promise<VinalfaChildrenResponse> {
  const response = await axiosInstance.get(
    `${baseURL}/vinalfa/sections/${encodeURIComponent(sectionHash)}/children`
  );
  return response.data as VinalfaChildrenResponse;
}

export async function fetchVinalfaSectionParts(
  sectionHash: string
): Promise<VinalfaPartsResponse> {
  const response = await axiosInstance.get(
    `${baseURL}/vinalfa/sections/${encodeURIComponent(sectionHash)}/parts`
  );
  return response.data as VinalfaPartsResponse;
}
